const primereactTR = {
    startsWith: 'İle başlar',
    contains: 'İçerir',
    notContains: 'İçermez',
    endsWith: 'İle biter',
    equals: 'Eşittir',
    notEquals: 'Eşit değildir',
    noFilter: 'Filtresiz',
    filter: 'Filtrele',
    lt: 'Küçüktür',
    lte: 'Küçük eşittir',
    gt: 'Büyüktür',
    gte: 'Büyük eşittir',
    dateIs: 'Tarih eşittir',
    dateIsNot: 'Tarih eşit değildir',
    dateBefore: 'Tarih öncesi',
    dateAfter: 'Tarih sonrası',
    clear: 'Temizle',
    apply: 'Uygula',
    matchAll: 'Tümüyle eşleşsin',
    matchAny: 'Herhangi biri eşleşsin',
    addRule: 'Kural ekle',
    removeRule: 'Kural sil',
    accept: 'Evet',
    reject: 'Hayır',
    choose: 'Seç',
    upload: 'Yükle',
    cancel: 'İptal',
    completed: 'Tamamlandı',
    pending: 'Bekliyor',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB'],
    dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    dayNamesShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
    dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
    monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
    monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    today: 'Bugün',
    weekHeader: 'Hf',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Zayıf',
    medium: 'Orta',
    strong: 'Güçlü',
    passwordPrompt: 'Şifre giriniz',
    emptyFilterMessage: 'Sonuç bulunamadı',
    emptyMessage: 'Uygun seçenek yok',
    aria: {
        trueLabel: 'Doğru',
        falseLabel: 'Yanlış',
        nullLabel: 'Seçilmedi',
        star: '1 yıldız',
        stars: '{star} yıldız',
        selectAll: 'Tümünü seç',
        unselectAll: 'Tüm seçimleri kaldır',
        close: 'Kapat',
        previous: 'Önceki',
        next: 'Sonraki',
        navigation: 'Navigasyon',
        scrollTop: 'Yukarı çık',
        moveTop: 'En üste taşı',
        moveUp: 'Yukarı taşı',
        moveDown: 'Aşağı taşı',
        moveBottom: 'En alta taşı',
        moveToTarget: 'Hedefe taşı',
        moveToSource: 'Kaynağa taşı',
        moveAllToTarget: 'Tümünü hedefe taşı',
        moveAllToSource: 'Tümünü kaynağa taşı',
        pageLabel: 'Sayfa {page}',
        firstPageLabel: 'İlk sayfa',
        lastPageLabel: 'Son sayfa',
        nextPageLabel: 'Sonraki sayfa',
        previousPageLabel: 'Önceki sayfa',
        rowsPerPageLabel: 'Sayfa başına satır',
        jumpToPageDropdownLabel: 'Sayfaya git açılır listesi',
        jumpToPageInputLabel: 'Sayfaya git giriş alanı',
        selectRow: 'Satırı seç',
        unselectRow: 'Satır seçimini kaldır',
        expandRow: 'Satırı genişlet',
        collapseRow: 'Satırı daralt',
        showFilterMenu: 'Filtre menüsünü göster',
        hideFilterMenu: 'Filtre menüsünü gizle',
        filterOperator: 'Filtre operatörü',
        filterConstraint: 'Filtre koşulu',
        editRow: 'Satırı düzenle',
        saveEdit: 'Düzenlemeyi kaydet',
        cancelEdit: 'Düzenlemeyi iptal et',
        listView: 'Liste görünümü',
        gridView: 'Izgara görünümü',
        slide: 'Slayt',
        slideNumber: '{slideNumber}',
        zoomImage: 'Görseli büyüt',
        zoomIn: 'Yakınlaştır',
        zoomOut: 'Uzaklaştır',
        rotateRight: 'Sağa döndür',
        rotateLeft: 'Sola döndür'
    }
};

export default primereactTR;